import React from 'react';
import {
  BooleanField,
  DateField,
  List,
  TextField,
  SearchInput,
  CheckboxGroupInput,
  BooleanInput,
  NumberInput,
  DateInput,
  TopToolbar,
  FilterButton,
  SelectColumnsButton,
  DatagridConfigurable,
} from 'react-admin';
import { USER_ROLES_LIST } from '../../constants';

const roleChoices = USER_ROLES_LIST.map((role) => ({ id: role, name: role }));

const userFilters = [
  <SearchInput source="q" alwaysOn key="q" />,
  <CheckboxGroupInput source="roles" choices={roleChoices} key="roles" />,
  <NumberInput source="totalEvents" min={0} key="totalEvents" />,
  <NumberInput source="totalReported" min={0} key="totalReported" />,
  <DateInput source="dateCreatedStart" key="dateCreated_start" />,
  <DateInput source="dateCreatedEnd" key="dateCreated_end" />,
  <BooleanInput
    label="Block active"
    source="isBanned"
    size="medium"
    key="block_active"
    format={(value) => (!value ? false : true)}
  />,
];

export const UsersList = () => {
  return (
    <List
      filters={userFilters}
      actions={
        <TopToolbar>
          <FilterButton />
          <SelectColumnsButton />
        </TopToolbar>
      }
    >
      <DatagridConfigurable rowClick="edit">
        <TextField source="firstName" label="First Name" />
        <TextField source="lastName" label="Last Name" />
        <TextField
          source="nickname"
          label="Nickname"
          noWrap
          maxWidth="100px"
          display="block"
        />
        <TextField source="role" label="Role" />
        <DateField source="dateCreatedEvent" label="Last event" />
        <TextField source="totalEvents" label="Events" />
        <TextField source="totalReported" label="Reported" />
        {/* <TextField source="totalReports" label="Num reports" /> */}
        <DateField source="dateBannedTo" label="Blocked Till" />
        <BooleanField source="isBanned" label="Block active" />
        <DateField source="dateCreated" label="Date created" />
      </DatagridConfigurable>
    </List>
  );
};
